const ABBREVIATIONS: Record<string, string> = {
  st: 'street',
  rd: 'road',
  hwy: 'highway',
  hyw: 'highway',
  hyws: 'highways',
  mt: 'mount',
  pl: 'place',
  ave: 'avenue',
  pr: 'parade',
  dr: 'drive',
  cres: 'crescent',
  sh: 'state highway',
  nh: 'national highway',
};

const normalize = (input: string, abbreviations?: Record<string, string>): string => {
  const _abbreviations = abbreviations ?? ABBREVIATIONS;

  return input
    .toLowerCase()
    .replace(/\./g, '') // remove dots (St. → St)
    .replace(/,/g, ' ') // unify separators
    .split(/\s+/) // split into words
    .map(word => _abbreviations[word] || word)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
};

const similarity = (a: string, b: string): number => {
  if (!a || !b) return 0;
  if (a === b) return 1;

  // Simple Jaccard similarity based on word tokens.
  // this is not perfect, but helps catch cases like extra words, spelling mistakes in a single word if rest of words match.
  const aTokens = new Set(a.split(' '));
  const bTokens = new Set(b.split(' '));

  // intersection
  let intersection = 0;
  aTokens.forEach(x => {
    if (bTokens.has(x)) intersection++;
  });

  // union
  const unionSet = new Set<string>();
  aTokens.forEach(x => unionSet.add(x));
  bTokens.forEach(x => unionSet.add(x));

  const union = unionSet.size;

  return union === 0 ? 0 : intersection / union;
};

export const matchAddress = (
  serviceAddr: string,
  nzPostAddr: string,
  abbreviations?: Record<string, string>
): boolean => {
  const [sStreet, sSuburb, sCity, sPost] = serviceAddr
    .split(',')
    .map(i => normalize(i, abbreviations));

  const nzParts = nzPostAddr.split(',').map(i => normalize(i, abbreviations));
  // const [nzStreet, nzSuburb, nzCityPost] = nzParts;
  const nzCityPost = nzParts.pop() ?? '';
  const nzSuburb = nzParts.pop() ?? '';
  const nzStreet = nzParts.join(' '); // along with unit/flat if any

  const tokens = nzCityPost.trim().split(' ');
  const nzPost = tokens[tokens.length - 1];
  const nzCity = tokens.slice(0, -1).join(' ');

  if (sPost && nzPost && sPost !== nzPost) return false;

  const streetScore = similarity(sStreet, nzStreet);
  const suburbScore = similarity(sSuburb, nzSuburb);
  const cityScore = similarity(sCity, nzCity);
  const postalScore = 1;

  const total = streetScore * 0.5 + postalScore * 0.2 + suburbScore * 0.15 + cityScore * 0.15;

  return total >= 0.8;
};
